$(document).ready(function() {
// Swiper: Slider
  if($(window).width() < 767){
    new Swiper('.half-teaser-list__content', {        
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },       
      slidesPerView: 1
    }); 
  }
   
 $('.half-teaser-list__item').hover(function (e) {   
     $('.half-teaser-list__item').each(function() {
       $(this).removeClass('half-teaser-list__item--active');
      });
     $(this).addClass('half-teaser-list__item--active'); 
 });
});
